import styled from 'styled-components';

export const PricingFAQsStyled = styled.div`
  .pricing-faqs-content {
    padding: 12px;
    background-color: #e3e3e3;
    border-radius: 8px;
  }
`;
